import dayjs from "dayjs";

/**
 * Manage the conversion between DMP string date and Date.
 * Example of date string: 20180709081444
 */
export default {
  /**
   * Transforms a DMP document date string to a JS date.
   * Example of date string: 20180709081444
   * These date are considered UTC, we thus ask moment to get them in the local
   * time zone.
   *
   * @param {string} dmpStrDate - a DMP document date string
   * @return {Date} a JavaScript date
   */
  strToDate: function (dmpStrDate: string): Date {
    return dayjs.utc(dmpStrDate, "YYYYMMDDHHmmss").toDate();
  },

  /**
   * @param {Date} date - a JavaScript date
   * @return {string} a DMP document date string
   */
  dateToStr: function (date: Date): string {
    return dayjs.utc(date).format("YYYYMMDDHHmmss");
  }
};
